import React from 'react';
import {
    DateField,
    DisabledInput,
    Edit,
    email,
    SelectInput,
    SimpleForm,
    TextInput
} from 'react-admin';
import {
    ArrayInput,
    BooleanInput,
    SimpleFormIterator,
} from 'ra-ui-materialui';

export const UserEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <DisabledInput label="ID" source="id" />
            <TextInput label="Username" source="username" />
            <TextInput label="First Name" source="first_name" />
            <TextInput label="Last Name" source="last_name" />
            <TextInput label="Email" type="email" validate={ email() } source="email" />
            <TextInput label="Password" type="password" source="plain_password" />
            <BooleanInput label="Claimed?" source="claimed" />
            <BooleanInput label="Enabled?" source="enabled" />
            <BooleanInput label="Opted In?" source="opted_in" />
            <TextInput label="Confirmation Token" source="confirmation_token" />
            <ArrayInput label="Roles" source="roles">
                <SimpleFormIterator>
                    <SelectInput choices={[
                        { id: 'ROLE_USER', name: 'ROLE_USER' },
                        { id: 'ROLE_ADMIN', name: 'ROLE_ADMIN' },
                    ]} />
                </SimpleFormIterator>
            </ArrayInput>
            <DateField label="Last Update" disabled source="updated_at" showTime />
            <DateField label="Created" disabled source="created_at" showTime />
        </SimpleForm>
    </Edit>
)
